export default {
    LoadMessageSuggestionDatapoint: {
        datapoint: {
            name: 'Search_LoadMessageSuggestion',
            customData: function (isOpenedInTab) { return [isOpenedInTab]; },
        },
    },
};
//# sourceMappingURL=datapoints.js.map